import { useNavigate } from "react-router-dom"


export const Error404 = () => {

  const navigate = useNavigate()

  return (
    <>
      <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
        <div className="bg-overlay"></div>
        
        <div className="auth-page-content overflow-hidden pt-lg-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-5">
                        <div className="card overflow-hidden">
                            <div className="card-body p-4">
                                <div className="text-center">
                                    <lord-icon className="avatar-xl" src="https://cdn.lordicon.com/spxnqpau.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c"></lord-icon>
                                    <h1 className="text-primary mb-4">Oops !</h1>
                                    <h4 className="text-uppercase">Sorry, Page not Found 😭</h4>
                                    <p className="text-muted mb-4">The page you are looking for not available!</p>
                                    <button onClick={() => navigate(-1)} className="btn btn-success"><i className="mdi mdi-home me-1"></i>Back to home</button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    

                </div>
                
            </div>
            
        </div>
        
    </div>
    </>
  )

}